module.exports = __webpack_public_path__ + "static/media/omega.c0f509a4.svg";